import { render, staticRenderFns } from "./GrafLoga.vue?vue&type=template&id=42d57f04&"
import script from "./GrafLoga.vue?vue&type=script&lang=ts&"
export * from "./GrafLoga.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports